export const getMemberFullName = (firstName, lastName, suffix) => {
    let name = `${firstName} ${lastName}`;

    if (suffix) {
        name += ` ${suffix}`;
    }

    return name;
};

export const getMemberURL = id => `${window.location.protocol}//${window.location.hostname}/member/profile/${id}`;
export const getMemberDesignations = designations => {
    if (!designations) return '';
    return designations.map(d => d.key).join(', ');
};

export const getNewMember = () => ({
    email: null,
    first_name: null,
    last_name: null,
    title: null,
    work_phone: null,

    // id: null,
    // company_id: null,
    // deferred_company_id: null,
    // deferred_email: null,
    // dirty: null,
    // birthdate: null,
    // casl_implied_consent: null,
    // gdpr_consent: null,
    // home_phone: null,
    // member_type: null,
    // no_email_display: null,
    // nonmember_company: null,
    // official: null,
    // personal_responsibility: null,
    // source_code: null,
    // status: null,
    // casl_express_consent: null,
    // auto_renew: null,

    // ------------------------------

    // id: null,
    // company_id: null,
    // deferred_company_id: null,
    // deferred_email: null,
    // dirty: null,
    // birthdate: null,
    // casl_implied_consent: null,
    // email: null,
    // first_name: null,
    // gdpr_consent: null,
    // home_phone: null,
    // last_name: null,
    // member_type: null,
    // no_email_display: null,
    // nonmember_company: null,
    // official: null,
    // personal_responsibility: null,
    // source_code: null,
    // status: null,
    // title: null,
    // work_phone: null,
    // casl_express_consent: null,
    // auto_renew: null,
});
